var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-select"},[_c('div',{class:{
            'theme-active': _vm.active,
            'theme-plate': true
        },style:({
            background: this.colorBlockStyle
        }),on:{"click":function($event){return _vm.onSelectTheme(_vm.theme)}}}),(_vm.canRemoveTheme)?_c('div',{class:{ 'remove-theme': true, 'disable-remove': _vm.active && !_vm.allowRemove },on:{"click":function($event){_vm.active && !_vm.allowRemove ? null : _vm.onRemoveTheme(_vm.theme)}}},[_c('i',{staticClass:"fas fa-times"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }